<template>
  <div class="ClaimStep1">
    <div class="loading" id="loading" v-show = "loading"><div class="circle"></div></div>
    <div class="model">
        <div class="body">
            <p class="title"></p>
            <p class="content"></p>
            <p class="foot"></p>    
        </div>
    </div>
    <div class="loading" id="loading" style="display: none;"><div class="circle"></div></div>
    <div class="main" style="padding-bottom: 30px;">
        <p class="doc_title" style="margin-bottom:10px;">为了保障您的索赔权益，请确认你符合以下索赔范围并登记（可多选）：</p>
        <p class="doc_text"><span class="check" data-index="question1"></span>用户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行购物、转账等操作时，用户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致用户账户资金被盗的；</p>
        <p class="doc_text"><span class="check" data-index="question2"></span>用户欲前往合法网站进行购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使用户连接上了一个钓鱼网站，导致了用户账户资金被盗的；</p>
        <p class="doc_text"><span class="check" data-index="question3"></span>用户在合法网站正常操作购物、转账等操作的过程中，钓鱼热点非法获取了用户录入及传递的个人信息，导致用户信息泄露继而造成账户资金被盗；</p>
        <p class="doc_text"><span class="check" data-index="question4"></span>用户欲下载特定应用软件，用户连接的热点被劫持后，用户实际下载了仿冒恶意软件，且一般用户无法判断该软件的真伪。用户在仿冒恶意软件中录入个人信息，或仿冒软件将劫持的用户短信等个人信息发送至恶意第三方，从而导致用户账户资金遭受损失。</p>
        <p class="button" style="margin-top:15px;" @click="claimStep1">
            我要索赔登记
        </p>
        <p class="doc_a" ><router-link to="/claimFlow">了解索赔流程</router-link></p>
    </div>
  </div>
</template>

<script>
const AES = require('@/lib/Utils/AES').default
export default {
  name: 'ClaimStep1',
  mounted:function(){
      var _self = this;
      Utils.Bridge.call('getAppInfo',{
        success:function(o){
            _self.appinfo = o;
            
            _self.loading = true;
          let data = {
            "dhid":o.dhid,
            "uhid":o.uhid,
            "vcode":o.vcode
          }
          let ed = AES.Encrypt( JSON.stringify(data), AES.obj())
            _self.$http.post(_host + '/safe/get_order',{
              ed: ed,
            },{
                emulateJSON: true
            }).then(function(response){
                _self.loading = false;
                var json = response.body;
                if(json.m.has_list === true){
                    var list = json.m.list;
                    for(var att in list){
                        var value = list[att];
                        if(value=='2'){
                            $('.main .check[data-index='+att+']').addClass('checked');
                        }
                    }
                }
            })
        }
    });
    $('.main .doc_text').bind('click',function(){
        $(this).find('.check').toggleClass('checked');
    });
    //   Utils.Tracker.send({
    //     data: {
    //         f: 'wifiins',
    //         b: 'ins_sp'
    //     }
    // });
     _self.$trace.enterTraceDone({page: 7, step: 1})

  },
  data () {
    return {
        appinfo:'',
        loading:false
    }
  },
    methods:{
        claimStep1:function(){
            var _self = this;
            _self.$trace.trace('ins_claim_confirm', {step: 1, type: 'ind'})
            var params = {
                "dhid":_self.appinfo.dhid,
                "uhid":_self.appinfo.uhid,
                "vcode":_self.appinfo.vcode
            };
            var hasSelect = false;
            var traceObj = {}
            $('.main .check').each(function(index,ele){
                var dataId = $(ele).attr('data-index');
                if($(ele).hasClass('checked')){
                    params[dataId]='2';
                    traceObj[dataId]='2';
                    hasSelect = true;
                }else{
                    params[dataId]='1';
                }
            });
            _self.$trace.trace('ins_claim_btn', {...traceObj, type: 'ind'})
            console.log(`点我要索赔等级`)

            if(!hasSelect){
                safe.model({
                    title:'温馨提示',
                    content:'请选择索赔范围',
                    foot:'我知道了'
                });
                safe.bindModelEvent();
                return;
            }
            // Utils.Tracker.send({
            //     data: {
            //         f: 'wifiins',
            //         b: 'ins_sp1'
            //     }
            // });
            console.log(`点确认登记`)
          let ed = AES.Encrypt( JSON.stringify(params), AES.obj())
            this.$http.post(_host + '/safe/order_first',{ed: ed},{
                emulateJSON: true
            }).then(function(response){
                var json = response.body;
                if(json.c=='0000'){
                    _self.$router.push("/claimStep2?order_sn="+json.m.order_sn);
                }else{
                    safe.model({
                        title:'温馨提示',
                        content:json.m,
                        foot:'我知道了'
                    });
                    safe.bindModelEvent();
                }
            })
        }
    }
}
</script>

<style scoped>
.main{margin-top: 0}
.doc_text {padding-left: 45px;position: relative;}
.doc_text .check{
    display: block;
    position: absolute;
    left: 24px;
    top: 5px;
    width: 12px;
    height: 12px;
    background-repeat: no-repeat;
    background-position: top center;
    -webkit-background-size: 12px;
    background-size: 12px;
    background-image: url(../images/unselect.png);
}
.doc_text .checked{
    background-image: url(../images/select.png);
}
.doc_text textarea{width: 95%;margin-top: 2px;border: 1px solid #dbdbdb;resize: none;border-radius: 2px;line-height: 18px;}
.doc_text .inputTips{position: absolute;font-size: 13px; color: #cccccc; bottom: 8px; right: 10%;}
</style>



// WEBPACK FOOTER //
// ClaimStep1.vue?69f72c37